import { createPortal } from "react-dom";
import { Prices } from "../prices";
import { missingImageURL } from "../../helpers/images";
import styles from "./ProductPrintTable.module.scss";

const ProductPrintTable = ({ products }) => createPortal(
    <section className={styles.print} data-catalog-print>
        <h1>Katalog proizvoda</h1>
        <table>
            <colgroup><col className={styles.imageColumn} /><col className={styles.codeColumn} /><col /><col className={styles.priceColumn} /></colgroup>
            <thead><tr><th>Slika</th><th>Šifra</th><th>Naziv proizvoda</th><th className={styles.price}>Cena</th></tr></thead>
            <tbody>{products.map((product) => (
                <tr key={product?.basic_data?.id_product ?? product.id}>
                    <td><img src={product?.images?.[0] ?? missingImageURL()} alt="" /></td>
                    <td className={styles.code}>{product?.basic_data?.sku}</td>
                    <td>{product?.basic_data?.name ?? product.name}</td>
                    <td className={styles.price}><Prices price={product.price} inventory={product.inventory} behaviours={product?.behaviours?.cart} /></td>
                </tr>
            ))}</tbody>
        </table>
    </section>, document.body
);

export default ProductPrintTable;
